import React from 'react';
import AppFooter from "../appFooter/appFooter";
import AppHeader from "../appHeader/appHeader";
import AppAdmin from "../appMenu/appAdmin";
import AppSetting from "../appSetting/appSetting";

/**
 * Layout comum para as páginas de gestão de clientes.
 * @param {React.Node} children - Componentes filhos a serem renderizados dentro do layout.
 */
function ClientesLayout({ children }) {
    return (
        <>
            <section className="content">
                <div className="container-fluid" style={{ marginTop: 18 }}>
                    {children}
                </div>
            </section>
        </>
    );
}

export default ClientesLayout;
